import { Text } from "@chakra-ui/react";

export default function SettingsDescription({ text }: { text: string }) {
  return (
    <Text fontSize="16px" lineHeight="28px" mb="26px">
      {text}
    </Text>
  );
}
